module.exports = {
  APPLINK: {
    IOS: 'https://apps.apple.com/cn/app/%E7%95%AA%E8%8C%84%E7%94%B5%E5%BD%B1-%E5%BD%B1%E8%A7%86%E5%A4%A7%E7%89%87%E9%AB%98%E6%B8%85%E8%A7%86%E9%A2%91/id1525848430',
    ANDROID: 'https://rr.tv'
  },
  BASE: {
    // 注意这里cdn的baseUrl是带 后面的path的；api的不带（由于后端cdn方案，是通过path区分环境的。。。）
    CDN: 'http://content.json.rr.tv/alpha-morpheus',
    // API: 'http://localhost:81'
    API: 'http://alpha-web-api.rr.tv'
  },
  SEO: {
    title: 'Loklok-影视大片高清视频',
    keyword:
      'Loklok,起跑线，爱的理想生活，温暖的味道，斗罗大陆，长歌行，进击的巨人，小舍得，山河令，指环王，追虎擒龙，速度与激情9，外太空的莫扎特，涉过愤怒的海，独行月球，哥斯拉，李焕英，人潮汹涌，悬崖之上',
    description:
      'Loklok涵盖新Netflix，HBO，Amazon，Hulu，Disney+，Apple+电影，各国新影院电影，经典高分。新片新播放器，国外高清4k，短视频，美剧，韩剧，日剧，小说，游戏，手游，热门，脱口秀，纪录片，电视剧，剧集，综艺'
  }
}
